// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedCurrency from "@insite/content-library/Components/LocalizedCurrency";
import Typography from "@store/MobiusOverrides/Typography/Typography";
import { orderSummaryProps, OrderSummaryProps } from "@store/Themes/common/props/order";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    total: state.pages.quickOrder.total,
    showPricing: state.context.showPricing,
    // Store Custom Code
    isAuthenticated: state.context.session.isAuthenticated,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const quickOrderSummaryProps: OrderSummaryProps = {
    totalValue: orderSummaryProps.totalValue,
    wrapper: orderSummaryProps.wrapper,
    titleWrapper: orderSummaryProps.titleWrapper,
    title: orderSummaryProps.title,
    itemWrapper: orderSummaryProps.itemWrapper,
    totalLabel: orderSummaryProps.totalLabel,
};

const styles = quickOrderSummaryProps;

const QuickOrderSummary: FC<Props> = ({ total, showPricing, /* Store Custom Code */ isAuthenticated }) => {
    if (!showPricing || !isAuthenticated /* Store Custom Code */) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="quickOrder_TotalPrice">
            <StyledWrapper {...styles.titleWrapper}>
                <Typography {...styles.title}>{translate("Order Summary")}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.itemWrapper}>
                <Typography {...styles.totalLabel}>{translate("Total")}</Typography>
                <Typography {...styles.totalValue}>
                    <LocalizedCurrency amount={total} />
                </Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(QuickOrderSummary),
    definition: {
        displayName: "Summary",
        group: "Quick Order",
        allowedContexts: ["QuickOrderPage"],
    },
};

export default widgetModule;
